<template>
    <div class="video-box">
        <div class="btn-box">
                <i class="iconfont icon-jiahao"></i>
                添加设备
        </div>
        <div class="content-box">
            <video :src="item.url" class="video-item" v-for="(item,index) in videoData" controls :key="index"></video>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                videoData:[
                    {
                        url:'',
                    },
                    {
                        url:'',
                    },
                    {
                        url:'',
                    },
                    {
                        url:'',
                    },
                    {
                        url:'',
                    },
                    {
                        url:'',
                    },
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
.video-box{
    height: 100%;
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.content-box{
    height: calc(100% - 6rem);
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    &> :nth-child(n){
        margin-left: 2rem;
    }
    &> :nth-child(3n+1){
        margin-left: 0;
    }
    &> :nth-child(n+4){
        margin-top: 2rem;
    }
}
.video-item{
    width: calc((100% - 6rem)/3);
    height: 30rem;
    background-color: antiquewhite;
}
</style>